import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconArrowLeft } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deletealocatedShift,
  getCategorys,
  getCompanys,
  getDepartments,
  getDesignation,
  getdutywithdate,
  getEmployee,
  getGroup,
  getProfitCenter,
  getShifEmployees,
  getShift,
  InsertDuty,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import { getSecureItem, setSecureItem } from "../../services/SecureStorage";
export default function ConsoldatedDuty() {
  const location = useLocation();
  const { state } = location || {};
  const UID = getSecureItem("userId");

  const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const DepId = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found  const isAdmin = getSecureItem("IsAdmin");
  const isAdmin = getSecureItem("IsAdmin");
  const [editCategoryModal, setEditCategoryModal] = useState(false);
  const [duties, setduties] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [department, setDepartment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryIdToDelete, setcategoryIdToDelete] = useState(null);
  const [date, setDate] = useState("");
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [tempShift, settempshift] = useState([]);
  const [Employees, setEmployees] = useState([]);
  const [toDate, setToDate] = useState("");
  const [shiftData, setShiftData] = useState([]);
  const [shiftemployeedata, setShiftEmployeesData] = useState([]);
  const [category, setCategory] = useState([]);
  const [group, setGroup] = useState([]);
  const [FilterProfitcenter, setFilterProfitcenter] = useState([]);
  const [filterMethod, setFilterMethod] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const navigate = useNavigate();
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [dutyData, setDutyData] = useState({
    Id: "",
    EmpId: [],
    ShiftId: "",
    DeptId: "",
    Remarks: "",
    DateValue: new Date().toISOString().split("T")[0], // Changed to string for consistency
    AddedBy: "",
    ShiftIdB:""
  });

  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0]);
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("An error occurred while fetching company details");
    }
  };

  const fetchduties = async () => {
    const data = {
      Date: date || state?.date || new Date().toISOString().split("T")[0],
      UserId: UID,
      ToDate: toDate || new Date().toISOString().split("T")[0],
    };

    try {
      setLoading(true);
      if (data.Date) {
        const response = await getdutywithdate(data);
        const details =
          isAdmin == 1
            ? response?.data?.data
            : response?.data?.data?.filter((el) => el?.DepartmentID == DepId);
        setduties(details);
        setDataFilter(details);
      }
    } catch (error) {
      console.error("Error fetching duty data", error);
    } finally {
      setLoading(false);
    }
  };
  const handleShowClick = async () => {
    fetchduties();
  };

  const openEditCategoryModal = (data) => {
    setEditCategoryModal(true);
      fetchShiftEmployees(data)
    if (!data) {
      setShiftData([]);
      return;
    }

    console.log(data,'dasdas');
    
    // Set initial duty data
    setDutyData({
  ...data,
  ShiftIdB: data?.ShiftBId,
  DateValue: data?.DateValue ? data.DateValue.split("T")[0] : "",
  UserId: UID || "",
  DepartmentId: data?.DepartmentID || "",
  EmpId: data?.EmpId ? [data.EmpId] : [],   // ← force array
  ToDate: data?.ToDate ? data.ToDate.split("T")[0] : new Date().toISOString().split("T")[0],
});

    let finalShiftData = [];

    if (isAdmin == 0) {
      // Non-admin: DepartmentId from localStorage
      const departmentId = getSecureItem("DepartmentId");

      let matchWithShift = tempShift.filter((el) =>
        el.DepartmentId
          ? el.DepartmentId.split(",")
              .map((d) => d.trim())
              .includes(departmentId)
          : false
      );

      // Remove duplicates
      finalShiftData = Array.from(
        new Map(matchWithShift.map((s) => [s.Id, s])).values()
      );

      // Add holiday / other shifts for ITI
      const selectedDepName = department.find(
        (el) => el.Id == departmentId
      )?.Name;

      if (selectedDepName?.toLowerCase().includes("iti")) {
        const holidayShifts = tempShift.filter(
          (el) =>
            el.Name?.toLowerCase().includes("holiday") ||
            el.Name?.toLowerCase().includes("other")
        );

        holidayShifts.forEach((shift) => {
          if (!finalShiftData.find((el) => el.Id === shift.Id)) {
            finalShiftData.push(shift);
          }
        });
      }
    } else {
      // Admin: DepartmentID from row data
      const departmentId = data?.DepartmentID;
      if (!departmentId) {
        setShiftData([]);
        return;
      }

      let matchWithShift = tempShift.filter((el) =>
        el.DepartmentId?.split(",")
          .map((d) => d.trim())
          .includes(departmentId)
      );

      finalShiftData = Array.from(
        new Map(matchWithShift.map((s) => [s.Id, s])).values()
      );

      const selectedDepName = department.find(
        (el) => el.Id == departmentId
      )?.Name;

      if (selectedDepName?.toLowerCase().includes("iti")) {
        const holidayShifts = tempShift.filter(
          (el) =>
            el.Name?.toLowerCase().includes("holiday") ||
            el.Name?.toLowerCase().includes("other")
        );

        holidayShifts.forEach((shift) => {
          if (!finalShiftData.find((el) => el.Id === shift.Id)) {
            finalShiftData.push(shift);
          }
        });
      }
    }

    setShiftData(finalShiftData);
  };

  const clearDataEdit = () => {
    setDutyData((ref) => ({
      ...ref,
      EmpId: [],
      ShiftId: "",
      DeptId: "",
      Remarks: "",
      DateValue: new Date(),
      AddedBy: "",
    }));
  };

  const handleChange = (selectedOptions) => {
    // ✅ Handle multi-select (like employee select)
    if (selectedOptions && Array.isArray(selectedOptions)) {
      const selectedEmployeeIds = selectedOptions.map((option) => option.value);
      setDutyData((prev) => ({
        ...prev,
        EmpId: selectedEmployeeIds,
        Id: "",
      }));
      return;
    }

    // ✅ Handle single-select and other inputs
    if (selectedOptions && selectedOptions.target) {
      const { name, value } = selectedOptions.target;

      let finalShiftData = [];

      // ✅ If department is selected
      if (name === "DepartmentId") {
        if (isAdmin == 1) {
          setSecureItem("ShiftEmpDepartmentId", value);
        }

        // ✅ Filter shifts by DepartmentId (comma-separated in shift)
        let matchWithShift = tempShift.filter((el) =>
          el.DepartmentId?.split(",")
            .map((d) => d.trim())
            .includes(value)
        );

        // ✅ Remove duplicates
        let uniqueShifts = Array.from(
          new Map(matchWithShift.map((s) => [s.Id, s])).values()
        );

        finalShiftData = uniqueShifts;

        // ✅ Check if department name includes "iti"
        const selectedDepName = department.find((el) => el.Id == value)?.Name;

        if (selectedDepName?.toLowerCase().includes("iti")) {
          const holidayShifts = tempShift.filter(
            (el) =>
              el.Name?.toLowerCase().includes("holiday") ||
              el.Name?.toLowerCase().includes("other")
          );

          const merged = [...uniqueShifts];
          holidayShifts.forEach((shift) => {
            if (!merged.find((el) => el.Id === shift.Id)) {
              merged.push(shift);
            }
          });

          finalShiftData = merged;
        }

        // ✅ Set filtered shift data
        setShiftData(finalShiftData);
      }

      // ✅ Update dutyData
      setDutyData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleChangeEdit = (event) => {
    const { name, value } = event.target;
    setDutyData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const empIdArray = Array.isArray(dutyData.EmpId)
        ? dutyData.EmpId
        : [dutyData.EmpId];

      const currentDate = new Date().toISOString().split("T")[0];
      const dateValue = dutyData.DateValue || currentDate;

      const data = {
        ...dutyData,
        DateValue: dateValue,
        EmpId: empIdArray,
        UserId: UID,
        ToDate: dateValue,
      };

      const response = await InsertDuty(data);

      if (response) {
        toast.success(response?.data?.message || "Inserted successfully");

        if (response?.data?.skippedMessages) {
          toast.success(response.data.skippedMessages);
        }

        if (date) {
          fetchduties();
        }

        // ✅ Just close modal (DO NOT call openEditCategoryModal)
        setEditCategoryModal(false);
      } else {
        toast.error(response?.data?.error);
      }
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setcategoryIdToDelete(null);
  };

  const confirmDelete = () => {
    if (categoryIdToDelete) {
      handledelete(categoryIdToDelete);
    }
    closeModal();
  };

  const handledelete = async (Id) => {
    const deleteData = {
      UserId: UID,
      Id,
    };

    try {
      // Call the API to delete the allocated shift
      const res = await deletealocatedShift(deleteData);

      // Check the response to determine the outcome
      if (res.data) {
        toast.success("Allocated Shift deleted successfully");
        fetchduties(); // Refresh the duties list after successful deletion
      } else {
        toast.error("Unable to delete the allocated shift");
      }
    } catch (error) {
      // Handle specific error responses
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting the category.";
        toast.error("Category is already in use and cannot be deleted.");
      } else {
        console.error("Error deleting the category:", error);
        toast.error("Error deleting the category. Please try again.");
      }
    }
  };

  const formatDate = (isoDate) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-US", options);
  };

  const handleFilterChange = async (selectedMethod, state, Id) => {
    setFilterMethod(selectedMethod);

    const requestData = {
      UserId: UID,
      name: selectedMethod, // Use the selected filter method here
      Id, // Use the selected option's Id
      Date: state?.date || date || new Date().toISOString().split("T")[0], // Use the current date if `date` is falsy
      ToDate: toDate || new Date().toISOString().split("T")[0], // Include ToDate
    };

    try {
      setLoading(true);

      const response = await getdutywithdate(requestData);
      const details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DepartmentID == DepId);
      setduties(details);
      setDataFilter(details);
    } catch (error) {
      console.error("Error fetching duty data", error);
    } finally {
      setLoading(false);
    }
  };

  const formatEDTime = (timeString) => {
    if (!timeString) return "-";

    const [datePart, timePart] = timeString.split("T");
    const year = datePart?.split("-")[0];
    const time = timePart?.slice(0, 5);

    if (time === "00:00" && year !== "1900") {
      return "24:00";
    }

    return time || "-";
  };

  const columnsFilter = [
    ...(state
      ? []
      : [
          {
            name: "Sl No",
            // Instead of selector, use cell
            cell: (row, index) => {
              // Access the current page and rows per page from the component props
              const firstRow = filteredItems.indexOf(row);
              return firstRow + 1;
            },
            grow: 0,
            width: "60px",
          },
        ]),

    // Conditionally include the "Shift" column
    ...(state
      ? []
      : [
          {
            name: "Shift",
            selector: (row) => row.ShiftName,
            sortable: true,
          },
          {
            name: "StartTime",
            selector: (row) => formatEDTime(row.StartTime),
            sortable: true,
          },
          {
            name: "EndTime",
            selector: (row) => formatEDTime(row.EndTime),
            sortable: true,
          },
        ]),
    {
      name: "Employee",
      selector: (row) => row.EmployeeName,
      sortable: true,
    },
    {
      name: "EmpCode",
      selector: (row) => row.EmpCode,
      sortable: true,
    },
    {
      name: "Assigned Date",
      selector: (row) => {
        const date = new Date(row.DateValue);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      },
      sortable: true,
    },

    {
      name: " Employee Department",
      selector: (row) => row.DepartmentName,
      sortable: true,
    },
    {
      name: "Added By",
      selector: (row) => row.UserName,
      sortable: true,
    },

    ...(state
      ? [
          {
            name: "Action",
            selector: (row) => {
              // const editable = isEditable(row.DateValue); // Check if the date is today or later
              return (
                <div className="flex items-stretch gap-10">
                  {/* Edit Button */}
                  <button
                    className={"bg-sky rounded-[4px] px-10 py-[8px] "}
                    onClick={() => openEditCategoryModal(row)} // Enable only if editable
                    // disabled={!editable} // Disable button if not editable
                  >
                    <IconEdit className="text-white w-[18px] h-[18px]" />
                  </button>
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const filteredItems = Array.isArray(dataFilter)
    ? dataFilter.filter((item) => {
        if (state) {
          return (
            item?.ShiftName?.toLowerCase().includes(
              state.ShiftName.toLowerCase()
            ) &&
            (item?.EmployeeName?.toLowerCase().includes(
              filterText.toLowerCase()
            ) ||
              item?.ShiftName?.toLowerCase().includes(
                filterText.toLowerCase()
              ) ||
              item?.DepartmentName?.toLowerCase().includes(
                filterText.toLowerCase()
              ) ||
              String(item?.EmpCode)
                .toLowerCase()
                .includes(filterText.toLowerCase()) ||
              new Date(item?.DateValue)
                .toLocaleDateString("en-GB")
                .includes(filterText))
          );
        }
        // When state is not defined, apply general filtering logic
        return (
          item?.EmployeeName?.toLowerCase().includes(
            filterText.toLowerCase()
          ) ||
          item?.ShiftName?.toLowerCase().includes(filterText.toLowerCase()) ||
          item?.DepartmentName?.toLowerCase().includes(
            filterText.toLowerCase()
          ) ||
          String(item?.EmpCode)
            .toLowerCase()
            .includes(filterText.toLowerCase()) ||
          new Date(item?.DateValue)
            .toLocaleDateString("en-GB")
            .includes(filterText)
        );
      })
    : [];

  const exportToPdf = (date, toDate, duties, filterMethod) => {
    const filterLabels = {
      CategoryId: "Category",
      ProfitCenterID: "Profit Center",
      GroupId: "Group",
      DesignationId: "Designation",
      DepartmentID: "Department",
    };

    function getFilterLabel(filterMethod) {
      return filterLabels[filterMethod] || "Unknown";
    }
    const method = getFilterLabel(filterMethod);

    const methodName = duties.map((ek) => ek.SelectedMethodName);
    const uniqueMethodName = [...new Set(methodName)][0];

    const ToDate = toDate || new Date().toISOString().split("T")[0];

    // Helper function to convert date format
    const formatDate = (inputDate) => {
      const [year, month, day] = inputDate?.split("-");
      return `${day}-${month}-${year}`;
    };

    // Helper function to format time from ISO string
    const formatEDTime = (timeString) => {
      if (!timeString) return "-";

      const [datePart, timePart] = timeString.split("T");
      const year = datePart?.split("-")[0];
      const time = timePart?.slice(0, 5);

      if (time === "00:00" && year !== "1900") {
        return "24:00";
      }

      return time || "-";
    };

    const formattedFromDate = formatDate(date);
    const formattedToDate = formatDate(ToDate);

    const title = companyDetails.Name.toUpperCase();
    const subtitle = uniqueMethodName
      ? `Shift Allocation Report from ${formattedFromDate} to ${formattedToDate} ${method} is (${uniqueMethodName})`
      : `Shift Allocation Report - ${formattedFromDate} to ${formattedToDate}`;

    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;

    // Define columns to exclude
    const excludedColumns = [
      "id",
      "empid",
      "shiftid",
      "departmentid",
      "addedby",
      "systime",
      "selectedmethod",
      "selectedmethodname",
    ];

    // Group data by department name
    const groupedData = filteredItems.reduce((acc, item) => {
      const deptName = item.DepartmentName || "Unknown Department";
      if (!acc[deptName]) {
        acc[deptName] = [];
      }
      acc[deptName].push(item);
      return acc;
    }, {});

    // Define table columns based on actual data structure - Updated columns
    const tableColumns = [
      { name: "SL", key: null },
      { name: "Employee Name", key: "EmployeeName" },
      { name: "E_Code", key: "EmpCode" },
      { name: "Shift Name", key: "ShiftName" },
      { name: "Assign Date", key: "DateValue" },
      { name: "Start Time", key: "StartTime" },
      { name: "End Time", key: "EndTime" },
    ];

    // Filter out excluded columns
    const filteredTableColumns = tableColumns.filter(
      (col) => !excludedColumns.includes(col.key?.toLowerCase())
    );

    // Format date helper
    const formatDateValue = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
    };

    let currentY = 10;

    // Add main title (Company Name)
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    let textWidth = doc.getTextWidth(title);
    doc.text(title, (pageWidth - textWidth) / 2, currentY);
    currentY += 10;

    // Add subtitle (Report details)
    doc.setFontSize(10);
    doc.setFont(undefined, "normal");
    const wrappedSubtitle = doc.splitTextToSize(subtitle, pageWidth - 20);

    wrappedSubtitle.forEach((line) => {
      const subtitleWidth = doc.getTextWidth(line);
      doc.text(line, (pageWidth - subtitleWidth) / 2, currentY);
      currentY += 5;
    });

    currentY += 10;

    // Process each department group
    Object.entries(groupedData).forEach(([deptName, deptData], groupIndex) => {
      // Add department header
      doc.setFontSize(10);
      doc.setFont(undefined, "bold");
      doc.text(`Department: ${deptName}`, 10, currentY);
      currentY += 8;

      // Prepare table data for this department
      const tableRows = deptData.map((item, index) => {
        return filteredTableColumns.map((col) => {
          if (col.name === "SL") {
            return index + 1;
          }

          const value = item[col.key];

          // Format dates
          if (col.key === "DateValue") {
            return formatDateValue(value);
          }

          // Format times using the formatEDTime function
          if (col.key === "StartTime" || col.key === "EndTime") {
            return formatEDTime(value);
          }

          return value || "";
        });
      });

      const tableColumnNames = filteredTableColumns.map((col) => col.name);

      // Add table for this department
      doc.autoTable({
        head: [tableColumnNames],
        body: tableRows,
        startY: currentY,
        headStyles: {
          fillColor: false,
          textColor: 0,
          fontStyle: "bold",
          halign: "center",
          fontSize: 9,
          cellPadding: 2,
          minCellHeight: 6,
          lineWidth: 0.2,
        },
        bodyStyles: {
          fontSize: 8,
          cellPadding: 1.5,
          minCellHeight: 5,
          lineWidth: 0.1,
        },
        columnStyles: {
          0: {
            halign: "center",
            cellWidth: 10,
            fontSize: 8,
          },
          // Adjust column widths for time columns
          5: {
            halign: "center",
            cellWidth: 20,
          },
          6: {
            halign: "center",
            cellWidth: 20,
          },
        },
        theme: "plain",
        margin: { top: 10, left: 10, right: 10, bottom: 10 },
        tableLineWidth: 0.2,
        tableLineColor: [0, 0, 0],
        willDrawCell: function (data) {
          if (data.row.height < 5) {
            data.row.height = 5;
          }
          return true;
        },
      });

      // Update currentY for next department or signature
      currentY = doc.lastAutoTable.finalY + 15;

      // Check if this is the last department
      if (groupIndex === Object.keys(groupedData).length - 1) {
        // Add signature field
        if (currentY > doc.internal.pageSize.height - 30) {
          doc.addPage();
          currentY = 20;
        }

        // Add signature label and line
        doc.setFontSize(10);
        doc.setFont(undefined, "bold");
        doc.text("Signature:", 10, currentY);
        currentY += 5;
        doc.setLineWidth(0.2);
        doc.line(10, currentY, 60, currentY); // Draw a 50mm line for signature
        currentY += 10; // Add some space after the signature line
      } else {
        // Check if we need a new page for the next department
        if (currentY > doc.internal.pageSize.height - 30) {
          doc.addPage();
          currentY = 20;
        }
      }
    });

    // Save the PDF
    doc.save(
      `Shift-Allocation-Report_${formattedFromDate}_to_${formattedToDate}.pdf`
    );
  };
  const exportToExcel = (date, toDate) => {
    try {
      const formatDate2 = (inputDate) => {
        const [year, month, day] = inputDate.split("-");
        return `${day}-${month}-${year}`;
      };
      const ToDate = toDate || new Date().toISOString().split("T")[0];

      // Convert the dates
      const formattedFromDate = formatDate2(date);
      const formattedToDate = formatDate2(ToDate);

      const title = `${companyDetails.Name} Shift Allocation Report - ${
        formattedFromDate || "Start"
      } to ${formattedToDate}`;

      if (!filteredItems || filteredItems.length === 0) {
        console.error("No data available for export");
        return;
      }

      // Map data with custom structure
      const exportData = filteredItems.map((item, index) => ({
        "Sl No": index + 1,
        Date: formatDate(item.DateValue),
        Shift: item.ShiftName,
        Employee: item.EmployeeName,
        Department: item.DepartmentName,
        "Added By": item.UserName,
      }));

      const headers = [
        "Sl No",
        "Date",
        "Shift",
        "Employee",
        "Department",
        "Added By",
      ];

      // Create worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(exportData, {
        header: headers,
        skipHeader: true,
      });
      const workbook = XLSX.utils.book_new();

      // Add title
      XLSX.utils.sheet_add_aoa(worksheet, [[title]], { origin: "A1" });

      // Add headers below the title
      XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A2" });

      // Add data below headers
      XLSX.utils.sheet_add_aoa(
        worksheet,
        exportData.map((item) => headers.map((header) => item[header])),
        { origin: "A3" }
      );

      // Merge cells for the title
      worksheet["!merges"] = [
        {
          s: { r: 0, c: 0 },
          e: { r: 0, c: headers.length - 1 },
        },
      ];

      // Adjust title row height
      worksheet["!rows"] = [{ hpt: 30 }];

      // Add basic styling
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const address = XLSX.utils.encode_col(C) + "2";
        if (worksheet[address]) {
          worksheet[address].s = {
            font: { bold: true },
            alignment: { horizontal: "center" },
          };
        }
      }

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Shift Allocation Report"
      );

      // Dynamic filename
      const filename = `Shift-Allocation-Report_${
        date || "Start"
      }_to_${ToDate}.xlsx`;

      // Save the workbook
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("An error occurred during export:", error);
    }
  };

  const subHeaderComponentMemo = useMemo(() => {}, [
    filterText,
    resetPaginationToggle,
  ]);

  //--------------------------for fetchinh employees data in multiple selectbox===========
  const fetchShiftEmployees = async (data) => {
    console.log(data,'sdasd');
    
    const details = {
      Date: dutyData.DateValue,
      UserId: UID,
      DepartmentId:data?.DepartmentID
    };
    try {
      if (details.Date) {
        const data = await getShifEmployees(details);
        setShiftEmployeesData(data.data.data);
      }
    } catch (error) {
      console.error("Error fetching ShiftEmployes", error);
    }

    setLoading(false);
  };
  //fetching shif

  const fetchShifts = async () => {
    try {
      const data = await getShift(UID);
      settempshift(data.data.data);
    } catch (error) {
      console.error("Error fetching shifts", error);
    }
  };

  const fetchEmployees = async () => {
    try {
      const data = await getEmployee(UID);
      setEmployees(data.data.data);
    } catch (error) {
      console.error("Error fetching shifts", error);
    }
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults); // Update state with the filtered data
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  useEffect(() => {
    const fetchcategory = async () => {
      try {
        const response = await getCategorys(UID);
        setCategory(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchcategory();
  }, []);

  useEffect(() => {
    const fetchdesignation = async () => {
      try {
        const response = await getDesignation(UID);

        setDesignation(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchdesignation();
  }, []);

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await getGroup(UID);

        setGroup(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchGroup();
  }, []);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);

        setDepartment(response.data.data);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchDepartment();
  }, []);

  useEffect(() => {
    const fetchfilterProfitecenter = async () => {
      try {
        const response = await getProfitCenter(UID);
        setFilterProfitcenter(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    fetchfilterProfitecenter();
  }, [UID]); // Add UID here if it can change

  useEffect(() => {
    const dataMapping = {
      CategoryId: category?.data?.data,
      ProfitCenterID: FilterProfitcenter?.data?.data,
      GroupId: group?.data?.data,
      DesignationId: designation?.data?.data,
      DepartmentID: department,
    };
    setDropdownOptions(dataMapping[filterMethod] || []);
  }, [
    filterMethod,
    category,
    FilterProfitcenter,
    group,
    designation,
    department,
  ]);

  useEffect(() => {
    // Get current date in YYYY-MM-DD format
    // Set the date state
    const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
    setDate(currentDate);
    setLoading(true);
    fetchShiftEmployees();
    fetchShifts();
    fetchduties();
    fetchEmployees();
    fetchCompanyDetails();
  }, []);

  useEffect(() => {
    fetchShiftEmployees(dutyData);
  }, [dutyData.DateValue,]);

  useEffect(() => {
    if (state) {
      setDate(state.date);
    }
  }, [state]);

  useEffect(() => {
    setToDate(state?.ToDate);
  }, [state]);

  useEffect(() => {
    fetchduties();
  }, [toDate]);



  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this category?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="mb-8 p-4">
        {/* Main container with breadcrumb and action area */}
        <div className="flex flex-col lg:flex-row justify-between gap-4">
          <Breadcrumb title="Detailed Duty Report" />

          {/* Action Area */}
          <div className="w-full flex flex-wrap items-center gap-4">
            {/* From Date */}
            <div className="flex items-center gap-2">
              <label
                htmlFor="date-input"
                className="text-sm font-medium text-gray-700 whitespace-nowrap"
              >
                From
              </label>
              <input
                type="date"
                id="date-input"
                className="w-36 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>

            {/* To Date */}
            <div className="flex items-center gap-2">
              <label
                htmlFor="toDate"
                className="text-sm font-medium text-gray-700 whitespace-nowrap"
              >
                To
              </label>
              <input
                type="date"
                id="toDate"
                className="w-36 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={toDate || new Date().toISOString().split("T")[0]}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            {/* Show Button */}
            <button
              className="btn btn-primary whitespace-nowrap"
              onClick={handleShowClick}
            >
              Show
            </button>

            {/* Filter Method Dropdown */}
            <select
              id="filter-method"
              name="filter-method"
              className="w-48 px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:border-gray-600"
              value={filterMethod}
              onChange={(e) => setFilterMethod(e.target.value)}
            >
              <option value="">Filter By</option>
              <option value="CategoryId">Category</option>
              <option value="ProfitCenterID">Profit Center</option>
              <option value="GroupId">Group</option>
              <option value="DesignationId">Designation</option>
              <option value="DepartmentID">Department</option>
            </select>

            {/* Dynamic Options Dropdown */}
            <select
              id="dynamic-options"
              name="dynamic-options"
              className="w-48 px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:border-gray-600"
              onChange={(e) => {
                const selectedOption = dropdownOptions.find(
                  (option) => option.Id.toString() === e.target.value
                );
                if (selectedOption) {
                  handleFilterChange(
                    filterMethod,
                    selectedOption.FromDate,
                    selectedOption.Id,
                    selectedOption.ToDate,
                    filterMethod
                  );
                }
              }}
            >
              <option value="">Choose One</option>
              {dropdownOptions.length > 0 &&
                dropdownOptions.map((option) => (
                  <option key={option.Id} value={option.Id}>
                    {option.Name}
                  </option>
                ))}
            </select>

            {/* Search & Clear */}
            <div className="flex items-center gap-2 p-2 bg-gray-100 rounded-md">
              <button
                className="bg-sky hover:bg-sky-600 text-white rounded px-3 py-2 flex items-center justify-center"
                onClick={handleFilterClick}
              >
                <IconFilter className="w-[18px] h-[18px]" />
              </button>
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by shift/Emp/Code/Assigned Date/dep/Addedby"
                className="w-[64] px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                onClick={handleClear}
                className="btn btn-danger whitespace-nowrap"
              >
                Clear
              </button>
            </div>

            {/* Export Buttons */}
            {!state && filteredItems.length > 0 && (
              <>
                <button
                  onClick={() => exportToExcel(date, toDate)}
                  className="btn btn-success"
                >
                  Excel
                </button>
                <button
                  onClick={() =>
                    exportToPdf(date, toDate, duties, filterMethod)
                  }
                  className="btn btn-danger"
                >
                  PDF
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={duties}
          onFilter={handleFilter}
          con
        />
      )}

      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        {!state ? (
          <div className="flex"></div>
        ) : (
          <div className="w-full flex items-center justify-between text-3xl mt-2">
            {/* Back Icon on the left */}
            <div className="flex items-center">
              <IconArrowLeft
                style={{ cursor: "pointer", color: "red" }}
                size={30}
                onClick={() => navigate(-1)}
              />
            </div>

            {/* Heading (ShiftName) in the center */}
            <div className="text-center flex-1">
              {state.ShiftName}-{state.StartTime}-{state.EndTime}
            </div>

            {/* Date on the right */}
          </div>
        )}

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {/* ==========================================================================edit=========================================================================================  */}
      {editCategoryModal && (
        <>
          <div className="fixed p-15 w-full max-w-[750px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit Duty
                <span className="absolute top-0 right-0">
                  <button
                    onClick={() => setEditCategoryModal(false)}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form onSubmit={handleEdit} className="my-10 md:px-10 px-[7px]">
                <div className="my-10 md:px-10 px-[7px] max-h-[75vh] overflow-auto cus-scrollbar-point-bottom">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        From <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="date"
                        required
                        name="DateValue"
                        placeholder="date"
                        value={dutyData.DateValue}
                        onChange={handleChangeEdit}
                        disabled
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        To <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="ToDate"
                        required
                        name="ToDate"
                        placeholder="date"
                        value={dutyData.ToDate}
                        onChange={handleChangeEdit}
                        min={new Date().toISOString().split("T")[0]}
                      />
                    </div>
                    {isAdmin == 1 ? (
                      <div className="form-group flex col-span-12 flex-col">
                        <label>
                          Select Department{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          name="DepartmentId"
                          value={dutyData.DepartmentId || ""}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select department</option>
                          {department?.map((el) => (
                            <option key={el.Id} value={el.Id}>
                              {el.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null}
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Shift A <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="ShiftId"
                        value={dutyData.ShiftId || ""}
                        onChange={handleChangeEdit}
                        required
                      >
                        <option value="">Select Shift</option>
                        {shiftData.map((shift) => (
                          <option key={shift.Id} value={shift.Id}>
                            {shift.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                     <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Shift B 
                      </label>
                      <select
                        name="ShiftIdB"
                        value={dutyData.ShiftIdB || ""}
                        onChange={handleChangeEdit}
                      >
                        <option value="">Select Shift</option>
                        {shiftData.map((shift) => (
                          <option key={shift.Id} value={shift.Id}>
                            {shift.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Employee <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
  name="EmpId"
  value={dutyData?.EmpId || ""}          // ← remove [0]
  onChange={handleChangeEdit}
  required
  disabled
>
  <option value="">Select Employee</option>
  {shiftemployeedata.map((data) => (
    <option key={data.Id} value={data.Id}>
      {data.Name}
    </option>
  ))}
</select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="remarks"
                        name="Remarks"
                        placeholder="Remarks"
                        value={dutyData.Remarks}
                        onChange={handleChangeEdit}
                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"></div>
        </>
      )}
    </>
  );
}
